import React from "react";

const TermsOfService = () => {
  return (
    <div className="bg-[#f5f7fb] min-h-screen py-10 px-4">

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-10">

        {/* HEADER */}
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Terms of Service
        </h1>

        <p className="text-sm text-gray-500 mb-6">
          Last Updated: 2026
        </p>

        {/* INTRO */}
        <p className="text-gray-700 mb-6 leading-relaxed">
          Welcome to <b>LappyShop</b>. By accessing our website
          <a
            href="https://www.lappyshop.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 ml-1 underline"
          >
            www.lappyshop.com
          </a>,
          you agree to comply with these Terms of Service.
          Our platform provides refurbished laptops and accessories
          for personal and business use.
        </p>

        {/* SECTION */}
        <Section title="1. Use of Website">
          <p>
            This website is intended for personal, non-commercial use.
            You must not misuse the platform or violate any laws while using it.
          </p>
        </Section>

        <Section title="2. Account Responsibility">
          <ul className="list-disc pl-5 space-y-1">
            <li>You must be 18+ to create an account</li>
            <li>Keep your login details secure</li>
            <li>You are responsible for all activities on your account</li>
          </ul>
        </Section>

        <Section title="3. Product Information (Refurbished)">
          <p>
            We strive to provide accurate details for refurbished laptops,
            but slight variations in appearance or specifications may occur.
            Images are for reference purposes only.
          </p>
        </Section>

        <Section title="4. Pricing & Orders">
          <ul className="list-disc pl-5 space-y-1">
            <li>Prices may change without notice</li>
            <li>Orders can be cancelled if pricing errors occur</li>
            <li>Refund will be issued if payment is already made</li>
          </ul>
        </Section>

        <Section title="5. Payments">
          <p>
            We accept Credit Cards, Debit Cards, UPI, Net Banking,
            Wallets and COD (if available).
          </p>
        </Section>

        <Section title="6. Returns & Warranty">
          <p>
            Please refer to our Return Policy for detailed information
            about returns, refunds and warranty on refurbished laptops.
          </p>
        </Section>

        <Section title="7. Intellectual Property">
          <p>
            All content on LappyShop including logos, designs, and text
            are owned by us and cannot be copied without permission.
          </p>
        </Section>

        <Section title="8. User Conduct">
          <ul className="list-disc pl-5 space-y-1">
            <li>No fake reviews or misleading content</li>
            <li>No illegal or harmful activity</li>
            <li>No attempt to hack or damage the platform</li>
          </ul>
        </Section>

        <Section title="9. Limitation of Liability">
          <p>
            LappyShop is not responsible for indirect damages,
            delays, or losses caused due to technical issues or external factors.
          </p>
        </Section>

        <Section title="10. Termination">
          <p>
            We reserve the right to suspend or terminate accounts
            if these terms are violated.
          </p>
        </Section>

        <Section title="11. Governing Law">
          <p>
            These terms are governed by Indian laws.
            Any disputes will be handled in Indian courts.
          </p>
        </Section>

        <Section title="12. Updates to Terms">
          <p>
            We may update these Terms at any time.
            Continued use of the site means acceptance of updates.
          </p>
        </Section>

        {/* CONTACT */}
        <Section title="13. Contact Us">
          <p>
            📧 Email:{" "}
            <a
              href="mailto:support@lappyshop.com"
              className="text-blue-600 underline"
            >
              support@lappyshop.com
            </a>
            <br />

            📞 Phone:{" "}
            <a
              href="tel:+918700074576"
              className="text-blue-600 underline"
            >
              +91-8700074576
            </a>
            <br />

            🌐 Website:{" "}
            <a
              href="https://www.lappyshop.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              www.lappyshop.com
            </a>
          </p>
        </Section>

      </div>

    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="text-lg md:text-xl font-semibold mb-2">
      {title}
    </h2>
    <div className="text-gray-700 text-sm leading-relaxed">
      {children}
    </div>
  </div>
);

export default TermsOfService;